"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceDataPoints = DeviceDataPoints;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var device_1 = require("../../../features/apis/device");
var api_error_message_1 = require("../../../utils/api-error-message");
var device_metrics_1 = require("../../../utils/device-metrics");
var table_1 = require("../../table");
var button_component_1 = require("../../ui/button-component");
var text_component_1 = require("../../ui/text-component");
var ignore_data_point_modal_1 = require("./ignore-data-point-modal");
// Lists the data points this device has sent; anyone who can edit devices can ignore one, turn it back on or restore hidden readings.
function DeviceDataPoints(props) {
    var _this = this;
    var _a;
    var device = props.device, canEdit = props.canEdit;
    var _b = (0, react_3.useState)(null), ignoringMetric = _b[0], setIgnoringMetric = _b[1];
    var _c = (0, react_3.useState)(""), pendingKey = _c[0], setPendingKey = _c[1];
    var _d = (0, react_3.useState)(""), error = _d[0], setError = _d[1];
    var updateDataPoint = (0, device_1.useUpdateDeviceDataPointMutation)()[0];
    var requestInFlightRef = (0, react_3.useRef)(false);
    var requestTokenRef = (0, react_3.useRef)(0);
    (0, react_3.useEffect)(function () { return function () {
        requestTokenRef.current += 1;
    }; }, [device.id]);
    var dataPoints = (_a = device.dataPoints) !== null && _a !== void 0 ? _a : {};
    var metrics = (0, device_metrics_1.getDeviceMetrics)(device).filter(function (metric) { return dataPoints[metric.key]; });
    if (!metrics.length) {
        return null;
    }
    var handleAction = function (key, action) { return __awaiter(_this, void 0, void 0, function () {
        var requestToken, requestError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (requestInFlightRef.current) {
                        return [2 /*return*/];
                    }
                    requestToken = requestTokenRef.current;
                    requestInFlightRef.current = true;
                    setPendingKey("".concat(key, ":").concat(action));
                    setError("");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, updateDataPoint({ id: device.id, key: key, action: action }).unwrap()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    requestError_1 = _a.sent();
                    if (requestToken === requestTokenRef.current) {
                        setError((0, api_error_message_1.getApiErrorMessage)(requestError_1, "Unable to update this data point. Please try again."));
                    }
                    return [3 /*break*/, 5];
                case 4:
                    requestInFlightRef.current = false;
                    setPendingKey("");
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)(react_1.Card, { className: "rounded-md p-4 flex flex-col gap-3", children: [(0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "medium", weight: "bold", color: "dark-gray-1", label: "Data Points" }), (0, jsx_runtime_1.jsx)("div", { className: "flex flex-col divide-y divide-gray-100", children: metrics.map(function (metric) {
                    var dataPoint = dataPoints[metric.key];
                    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-wrap items-center justify-between gap-3 py-2", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: metric.icon, fontSize: 16, className: "text-medium-gray" }), (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "dark-gray-1", label: metric.label }), (0, jsx_runtime_1.jsx)(table_1.StatusBadge, { color: dataPoint.ignored ? "amber" : "green-soft", children: dataPoint.ignored ? "Ignored" : "Recording" }), dataPoint.ignored && dataPoint.autoTurnOn && ((0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "xsmall", color: "medium-gray", label: "Turns back on when readings are normal" }))] }), canEdit && ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2", children: [dataPoint.hiddenRanges.length > 0 && ((0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Restore Hidden Readings", variant: "ghost", isPending: pendingKey === "".concat(metric.key, ":restore"), isDisabled: Boolean(pendingKey), onPress: function () { return handleAction(metric.key, "restore"); } })), dataPoint.ignored ? ((0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Turn On", variant: "secondary", isPending: pendingKey === "".concat(metric.key, ":turnOn"), isDisabled: Boolean(pendingKey), onPress: function () { return handleAction(metric.key, "turnOn"); } })) : ((0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Ignore", variant: "secondary", isDisabled: Boolean(pendingKey), onPress: function () { return setIgnoringMetric(metric); } }))] }))] }, metric.key));
                }) }), error && ((0, jsx_runtime_1.jsx)("div", { role: "alert", children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "red-600", label: error }) })), ignoringMetric && (0, jsx_runtime_1.jsx)(ignore_data_point_modal_1.IgnoreDataPointModal, { isOpen: true, deviceId: device.id, metric: ignoringMetric, onClose: function () { return setIgnoringMetric(null); } })] }));
}
